import { useQuery } from '@apollo/client';
import { CheckOxpsSegmentsExistsDocument } from '../../../../../../../../graphql/query/audiences/CheckOxpsSegmentsExists.generated';

export const useHasOxpsSegments = (): boolean => {
  const { data: { segment_aggregate } = {} } = useQuery(CheckOxpsSegmentsExistsDocument);

  const totalCount = segment_aggregate?.aggregate?.count || 0;

  return totalCount > 0;
};
